export var getCacheVal = function getCacheVal(key) {
  var strValue = window.localStorage.getItem(key);
  var value = null;

  try {
    value = JSON.parse(strValue);
  } catch (e) {
    value = strValue;
  }

  return value;
};
export var setCacheVal = function setCacheVal(key, val) {
  return window.localStorage.setItem(key, JSON.stringify(val));
};
export var removeCacheVal = function removeCacheVal(key) {
  return window.localStorage.removeItem(key);
};